/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * YouTube 기본 언어 설정 (ko: 한국어, en: English, ja: 日本語, zh: 中文)

* `ko` - 한국어
* `en` - English
* `ja` - 日本語
* `zh` - 中文(简体)
* `th` - ไทย
* `pt-BR` - Português (BR)
* `es` - Español
* `id` - Bahasa Indonesia
* `vi` - Tiếng Việt
 */
export type Enumf6c0c600 = (typeof Enumf6c0c600)[keyof typeof Enumf6c0c600];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Enumf6c0c600 = {
  ko: "ko",
  en: "en",
  ja: "ja",
  zh: "zh",
  th: "th",
  "pt-BR": "pt-BR",
  es: "es",
  id: "id",
  vi: "vi",
} as const;
